import React, { useEffect, useRef, useState } from "react";
import styles from "./styles/Video.module.css";
import { useLanguage } from "../LanguageContext";

function Video({appMedia}) {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [videoSrc, setVideoSrc] = useState("");
    const { t } = useLanguage();

    const togglePlay = () => {
        const video = videoRef.current;
        if (video.paused) {
            video.play();
            setIsPlaying(true);
        } else {
            video.pause();
            setIsPlaying(false);
        }
    };

    const handleVideoEnded = () => {
        setIsPlaying(false);
        videoRef.current.currentTime = 0;
    };

    const updateVideoSrc = () => {
        const isMobile = window.innerWidth <= 575;
        const newSrc = isMobile
            ? appMedia[1].media_mobile
            : appMedia[1].media_desktop;

        setVideoSrc(newSrc);
    };

    useEffect(() => {
        const isMobile = window.innerWidth <= 575;

        if (videoRef.current && videoSrc && isMobile) {
            const video = videoRef.current;

            const handleCanPlay = () => {
                video.currentTime = 0;
            };

            video.addEventListener('canplay', handleCanPlay);
            video.load();

            return () => {
                video.removeEventListener('canplay', handleCanPlay);
            };
        }
    }, [videoSrc]);

    useEffect(() => {
        updateVideoSrc();
        window.addEventListener("resize", updateVideoSrc);
        return () => {
            window.removeEventListener("resize", updateVideoSrc);
        };
    }, []);


    return (
        <div className={styles.container}>
            <div className={styles.textBlock}>
                <h2>{t("video.heading")}</h2>
                <p dangerouslySetInnerHTML={{ __html: t("video.description") }} />
            </div>

            <div className={styles.videoWrapper}>
                <video
                    ref={videoRef}
                    className={styles.video}
                    preload="auto"
                    playsInline
                    disablePictureInPicture
                    controls={false}
                    controlsList="nodownload nofullscreen noremoteplayback"
                    onEnded={handleVideoEnded}
                    src={videoSrc}
                >
                    Your browser does not support the video tag.
                </video>
                <button onClick={togglePlay} className={styles.playPause}>
                    {isPlaying ? (
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0 31.0181V4.98195C0 1.88448 1.94946 0 5.15523 0H30.8448C34.0505 0 36 1.88448 36 4.98195V31.0181C36 34.1155 34.0505 36 30.8448 36H5.15523C1.94946 36 0 34.1155 0 31.0181Z"
                                fill="white"
                            />
                        </svg>
                    ) : (
                        <svg width="32" height="36" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2.82714 35.8105C1.16773 35.8105 0 34.5403 0 32.5122V3.29834C0 1.27017 1.16773 0 2.82714 0C3.70807 0 4.44558 0.307298 5.38796 0.860435L29.5211 14.8323C31.3035 15.8566 32 16.6351 32 17.9053C32 19.1754 31.3035 19.9539 29.5211 20.9782L5.38796 34.9706C4.44558 35.5032 3.70807 35.8105 2.82714 35.8105Z"
                                fill="white"
                            />
                        </svg>
                    )}
                </button>
            </div>
        </div>
    );
}

export default Video;